import { Column } from '@ant-design/plots';
import { useEffect, useState } from 'react';
import dashboardService from '../../../services/dashboard.service';

const TopGaragesBarChart = () => {
  const [data, setData] = useState([]);

  const fetch = async () => {
    const data = await dashboardService.fetchTopGaragesMonth();
    setData(data);
  };

  useEffect(() => {
    fetch();
  }, []);

  const config = {
    data,
    xField: 'garage',
    yField: 'total',
    label: {
      position: 'middle',
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      garage: { alias: 'Taller' },
      total: { alias: 'Certificaciones' },
    },
    color: '#1890ff',
  };

  return <Column {...config} />;
};

export default TopGaragesBarChart;
